module.exports = "https://www.gc-qa.gnp.com.mx/0bb66b30120f44d97f85465312e91456.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/iconvida.svg
// module id = 8139
// module chunks = 0